import { z } from 'zod';
import { MATTRESS_SCHEMA_VERSION } from './types';
const sleepPositionSchema = z.enum(['lateral', 'supino', 'prono', 'misto']);
const medicalConditionSchema = z.enum([
    'escoliose',
    'hernia-disco',
    'bico-papagaio',
    'lombalgia',
    'fibromialgia',
    'artrose',
    'ma-circulacao',
    'apneia',
    'dor-cervical',
    'dor-ombro-quadril',
]);
const clientProfileSchema = z.object({
    nomeCliente: z.string().max(120).optional(),
    pesoKg: z.number().positive().max(350).optional(),
    alturaCm: z.number().positive().max(260).optional(),
    posicaoDormir: sleepPositionSchema.optional(),
    condicoes: z.array(medicalConditionSchema).optional(),
    observacoes: z.string().max(1000).optional(),
});
const firmnessSchema = z.enum([
    'extra-soft',
    'soft',
    'medium-soft',
    'medium',
    'medium-firm',
    'firm',
    'extra-firm',
]);
const layerRoleSchema = z.enum([
    'core',
    'transition',
    'comfort',
    'top-comfort',
    'pillow-top',
    'euro-top',
]);
const finishTopTypeSchema = z.enum(['flat', 'quilted', 'pillow-top', 'euro-top']);
const quiltPatternSchema = z.enum(['diamond', 'square', 'lines', 'none']);
export const mattressDimensionsSchema = z.object({
    larguraMm: z.number().int().positive().max(2400),
    comprimentoMm: z.number().int().positive().max(2400),
    alturaTotalMm: z.number().nonnegative().max(800),
});
export const mattressLayerSchema = z.object({
    id: z.string(),
    nome: z.string().min(1).max(80),
    role: layerRoleSchema,
    materialId: z.string(),
    espessuraMm: z.number().int().positive().max(400),
    densidadeOpcional: z.number().positive().optional(),
    firmezaOpcional: firmnessSchema.optional(),
    corTecnicaOpcional: z.string().optional(),
    ordem: z.number().int().nonnegative(),
    stretchFactor: z.number().min(0).max(1).optional(),
    observacoes: z.string().max(500).optional(),
    visible: z.boolean(),
    locked: z.boolean(),
});
export const acabamentoSchema = z.object({
    topType: finishTopTypeSchema,
    lateralAcolchoada: z.boolean(),
    viesAplicado: z.boolean(),
    quiltPattern: quiltPatternSchema,
});
export const mattressProjectSchema = z.object({
    schemaVersion: z.literal(MATTRESS_SCHEMA_VERSION),
    id: z.string(),
    nome: z.string().min(1).max(120),
    dataCriacao: z.string().datetime(),
    dataAtualizacao: z.string().datetime(),
    dimensoes: mattressDimensionsSchema,
    listaDeCamadas: z.array(mattressLayerSchema).max(16),
    acabamento: acabamentoSchema,
    tecidoSuperiorId: z.string(),
    tecidoLateralId: z.string(),
    observacoes: z.string().max(1000).optional(),
    previewImage: z.string().optional(),
    perfilCliente: clientProfileSchema.optional(),
});
